import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { SolutionsAppService } from 'src/app/services/solutions-app.service';

@Component({
  selector: 'app-selected-project',
  template: `
    <div class="page">
      <div class="crumbs">
        <a routerLink="/home/manage-solutions/mySolutions">My Solutions</a>
        <span class="sep">›</span>
        <span class="cur">{{ project.project_name }}</span>
      </div>

      <div class="ehead">
        <div class="ico">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="13" rx="2"></rect>
            <path d="M8 21h8M12 17v4"></path>
          </svg>
        </div>
        <div class="mid">
          <h1>{{ project.project_name }}</h1>
        </div>
        <div class="acts">
          <label class="tog">
            <mat-checkbox [(ngModel)]="project.refresh_data_flag"></mat-checkbox>
            <span>Refresh data before each run</span>
          </label>

          <button class="btn-primary" (click)="runProject()">
            <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" stroke="none">
              <path d="M8 5v14l11-7z"></path>
            </svg>
            {{ checkedPipeline.length > 0 ? 'Run Selected' : 'Run' }}
          </button>

          <button class="btn-ghost">
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12Z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            Preview
          </button>

          <button class="btn-ghost" (click)="updateProject()">
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"></path>
              <path d="M17 21v-8H7v8M7 3v5h8"></path>
            </svg>
            Save
          </button>
        </div>
      </div>

      <router-outlet></router-outlet>
    </div>
  `,
  styleUrls: ['./selected-project.component.scss'],
})
export class SelectedProjectComponent implements OnInit {
  project = {
    project_name: '',
    project_id: '',
    created_dtm: '',
    project_desc: '',
    is_active: undefined,
    is_template: undefined,
    username: undefined,
    refresh_data_flag: undefined,
  };
  checkedPipeline: any = [];
  solutionId: any;
  versionId: any;
  constructor(
    private solutionServices: SolutionsAppService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: SharedFeaturesService
  ) {}
  ngOnInit() {
    this.solutionServices.myVariable$.subscribe((value) => {
      this.checkedPipeline = value;
    });
    let url: any = this.route.snapshot.paramMap.get('projectId');
    this.solutionId = this.route.snapshot.paramMap.get('solutionId');
    this.versionId = this.route.snapshot.paramMap.get('versionId');
    this.solutionServices
      .getAvailableProjects(
        { solution_id: this.solutionId },
        { version_id: this.versionId },
        url
      )
      .subscribe({
        next: (response: any) => {
          this.project = response;
        },
        error: (error: any) => {
          console.error('an error occurred', error);
        },
      });
  }

  runProject() {
    let temp: any = {
      project_ids:
        this.checkedPipeline.length > 0 ? [] : [this.project?.project_id],
      pipeline_ids: this.checkedPipeline.length > 0 ? this.checkedPipeline : [],
      node_ids: [],
      tags: [],
    };

    this.solutionServices
      .runVersionOrProjectOrPipelineOrNode(
        this.solutionId,
        this.versionId,
        temp
      )
      .subscribe({
        next: (response: any) => {
          this.snackBar.openSnackBar(
            `Run queued${response?.task_id ? ` (task #${String(response.task_id).slice(0, 8)})` : ''} — we'll let you know when it finishes.`,
            'Close',
            'success-snackbar'
          );
        },
        error: (error) => {
          this.snackBar.openSnackBar(
            error.error.error,
            'Close',
            'error-snackbar'
          );
        },
      });
  }

  updateProject() {
    this.solutionServices
      .updateProject(
        { solution_id: this.solutionId },
        { version_id: this.versionId },
        this.project,
        this.project.project_id
      )
      .subscribe(
        (response) => {
          this.snackBar.openSnackBar(
            `${this.project.project_name} details updated`,
            'Close',
            'success-snackbar'
          );
        },
        (error) => {
          this.snackBar.openSnackBar(
            error.error.error,
            'Close',
            'error-snackbar'
          );
        }
      );
  }
}
